import React, { useEffect, useState } from "react";
import "../../Registration/MainRegister/mainRegister.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../LoginWithMPIN/loginWithMPIN.css";
import axios from "../../../axios";
import { useDispatch, useSelector } from "react-redux";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
// import {
//   fetchSkills,
//   fetchDifficultyLevels,
//   fetchQuestionTypes,
//   fetchDomainData,
//   fetchAllStudentList,
//   fetchAllTeacherList,
// } from "./../../../redux/initialDataSlice";

import { setActiveMenu, setIsMenuExpended } from "../../../redux/PageSlice";
import ActiveMenuEnum from "../../../Enum/ActiveMenuEnum";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

export default function LoginSuccess() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const schoolId = JSON.parse(localStorage.getItem("schoolId"));
  const [showDropDown, setShowDropDown] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [academicYearList, setAcademicYearList] = useState([]);
  const [academicYearSessionList, setAcademicYearSessionList] = useState([]);
  const [selectedOptionAcademicYear, setSelectedOptionAcademicYear] =
    useState("");
  const [
    selectedOptionAcademicSessionYear,
    setSelectedOptionAcademicSessionYear,
  ] = useState("");
  const [academicYearTimeTableShiftList, setAcademicYearTimeTableShiftList] =
    useState([]);
  // setTimeout(() => {
  //   window.location.replace("/DcmTimeTable");
  // }, 3000);
  // const school_id = localStorage.getItem('schoolId')
  // useEffect(() => {
  //   dispatch(fetchSkills());
  //   dispatch(fetchDifficultyLevels());
  //   dispatch(fetchAllStudentList(JSON.parse(school_id)))
  //   dispatch(fetchAllTeacherList(JSON.parse(school_id)))
  //   dispatch(fetchDomainData())
  //   dispatch(fetchQuestionTypes(JSON.parse(school_id)));
  // }, [dispatch, school_id]);

  // useEffect(() => {
  //   dispatch(setIsMenuExpended(true));
  //   dispatch(setActiveMenu(ActiveMenuEnum.DSM));
  //   // window.location.replace("/DcmTimeTable")
  //   if (state.loginRes?.timetable_session.length === 0) {
  //     // localStorage.setItem('timeTableSessionId', JSON.stringify(""));
  //     updateLocalStore(null);
  //     navigate("/successpage");
  //   }
  //   if (state.loginRes?.timetable_session?.length === 1) {
  //     updateLocalStore(state.loginRes?.timetable_session[0].id);
  //     navigate("/successpage");
  //   }
  //   if (state.loginRes?.timetable_session?.length > 1) {
  //     setShowDropDown(true);
  //   }
  // }, []);

  useEffect(() => {
    const fetchAcademicYear = async () => {
      if (!schoolId) return;
      try {
        const response = await axios.get(
          `api/v1/school/academicYear/list/get/school/${schoolId}`,
        );
        setAcademicYearList(response?.data?.data);
      } catch (err) {
        console.log("Error", err);
      }
    };

    fetchAcademicYear();
  }, [schoolId]);

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
    updateLocalStore(event.target.value);
  };

  const handleChangeAcademicYear = async (event) => {
    const academicYearId = event.target.value;

    setSelectedOptionAcademicYear(academicYearId);
    localStorage.setItem("academicYearId", JSON.stringify(academicYearId));

    setSelectedOption("");
    setSelectedOptionAcademicSessionYear("");

    await fetchAcademicSessionYear(academicYearId);
  };

  // const fetchAcademicSessionYear = async (academicYearId) => {
  //   try {
  //     const response = await axios.get(
  //       `/api/v1/school/academicYearSession/get/academicYear/${academicYearId}`,
  //     );
  //     setAcademicYearSessionList(response?.data?.data);
  //   } catch (err) {
  //     console.log("Error", err);
  //   }
  // };

  const fetchAcademicSessionYear = async (academicYearId) => {
    try {
      const response = await axios.get(
        `/api/v1/school/academicYearSession/get/academicYear/${academicYearId}`,
      );

      const sessions = response?.data?.data || [];

      setAcademicYearSessionList(sessions);

      // Auto select first academic session
      if (sessions.length > 0) {
        const firstSession = sessions[0];

        setSelectedOptionAcademicSessionYear(firstSession.id);

        localStorage.setItem(
          "academicYearSessionId",
          JSON.stringify(firstSession.id),
        );

        // Fetch shifts
        const shiftResponse = await axios.get(
          `/api/v1/school/schoolSession/get/academicYear/${firstSession.academic_year_id}`,
        );

        const shifts = shiftResponse?.data?.data || [];

        setAcademicYearTimeTableShiftList(shifts);

        // Filter shifts for selected session
        const filteredShifts = shifts.filter(
          (item) => item.academicYearSessionId.id === firstSession.id,
        );

        // Auto select first shift
        if (filteredShifts.length > 0) {
          const firstShift = filteredShifts[0];

          setSelectedOption(firstShift.timeTableSession.id);

          updateLocalStore(firstShift.timeTableSession.id);
        }
      }
    } catch (err) {
      console.log("Error", err);
    }
  };

  const handleChangeAcademicSessionYear = (event) => {
    const selectedId = event.target.value; // This is the session id
    setSelectedOptionAcademicSessionYear(selectedId);

    localStorage.setItem("academicYearSessionId", JSON.stringify(selectedId));

    // Find full object
    const selectedItem = academicYearSessionList.find(
      (item) => item.id === selectedId,
    );
    if (selectedItem) {
      fetchTimeTableSession({
        academic_year_id: selectedItem.academic_year_id,
      });
    }
  };

  const fetchTimeTableSession = async (academicYearSessionId) => {
    try {
      const response = await axios.get(
        `/api/v1/school/schoolSession/get/academicYear/${academicYearSessionId?.academic_year_id}`,
      );
      setAcademicYearTimeTableShiftList(response?.data?.data);
    } catch (err) {
      console.log("Error", err);
    }
  };

  const handleContinue = () => {
    updateLocalStore(selectedOption);
    navigate("/successpage");
  };

  const updateLocalStore = (curTimetableSessionId) => {
    const Teacher_id = state.loginRes?.id;
    const emergencyNo = state.loginRes?.emergency_contact_number;
    const DOB = state.loginRes?.date_of_birth;
    const address = state.loginRes?.address;
    const gender = state.loginRes?.gender;


    //Storing  Class Teacher Role_Information Array in Local Storage
    const role_as_class_teacher =
      state.loginRes?.role_as_class_teacher?.filter(
        (item) => item.timetable_session.id === curTimetableSessionId,
      ) || [];
    const stringrole_as_class_teacher = JSON.stringify(role_as_class_teacher);
    if (stringrole_as_class_teacher?.length > 0) {
      localStorage.setItem(
        "role_as_class_teacher",
        stringrole_as_class_teacher,
      );
    } else {
      localStorage.setItem("role_as_class_teacher", JSON.stringify([]));
    }

    //Storing Cordinator Role_INfo

    const role_as_co_ordinator =
      state.loginRes?.role_as_co_ordinator?.filter(
        (item) => item.timetable_session.id === curTimetableSessionId,
      ) || [];
    const stringrole_as_co_ordinator = JSON.stringify(role_as_co_ordinator);

    if (role_as_co_ordinator?.length > 0) {
      localStorage.setItem("role_as_co_ordinator", stringrole_as_co_ordinator);
    } else {
      localStorage.setItem("role_as_co_ordinator", JSON.stringify([]));
    }

    //Storing general information in local storage
    const general_role =
      state.loginRes?.general_role?.filter(
        (item) => item.timetable_session.id === curTimetableSessionId,
      ) || [];
    const general_role_with_subject = general_role.filter(
      (item) => item.subjects_id.length > 0,
    );

    const stringgeneral_role = JSON.stringify(general_role_with_subject);
    if (stringgeneral_role?.length > 0) {
      localStorage.setItem("general_role", stringgeneral_role);
    } else {
      localStorage.setItem("general_role", JSON.stringify([]));
    }

    localStorage.setItem("Teacher_id", JSON.stringify(Teacher_id));
    localStorage.setItem(
      "emergency_contact_number",
      JSON.stringify(emergencyNo),
    );
    localStorage.setItem("date_of_birth", JSON.stringify(DOB));
    localStorage.setItem("address", JSON.stringify(address));
    localStorage.setItem("gender", JSON.stringify(gender));

    if (curTimetableSessionId !== null && curTimetableSessionId !== undefined) {
      localStorage.setItem(
        "timeTableSessionId",
        JSON.stringify(curTimetableSessionId),
      );
    } else {
      localStorage.setItem("timeTableSessionId", JSON.stringify(""));
    }
  };

  useEffect(() => {
    dispatch(setIsMenuExpended(true));
    dispatch(setActiveMenu(ActiveMenuEnum.DSM));

    if (academicYearList?.length > 0) {
      setShowDropDown(true);
    }

  }, [academicYearList]);

  return (
    <div className="TotalContainer d-md-flex">
      {/* <div className='MainContainer col-12 p-0   '> */}
      <div className="banner_box col-lg-3 col-md-5 m-0 p-0 col-12">
        <img
          className="banner_img "
          src="/Register-img/baner_img.jpg"
          alt="banner img"
        ></img>
      </div>
      {showDropDown && (
        <div
          className="col-md-5"
          style={{
            margin: "auto",
            fontWeight: "500",
            backgroundColor: "white",
            // border: "2px solid gray",
            borderRadius: "5px",
            padding: "20px 30px",
          }}
        >
          <div className="mb-4">
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Select Academic Year
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                value={selectedOptionAcademicYear || ""}
                onChange={handleChangeAcademicYear}
                className="dropDownBox"
                id="selectOption"
                name="academicYear"
                label="Select Academic Year"
              >
                {academicYearList?.map((item, index) => {
                  return (
                    <MenuItem key={index} value={item.id}>
                      {item.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </div>
          <div className="mb-4">
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Select Academic Year Session
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                value={selectedOptionAcademicSessionYear || ""}
                onChange={handleChangeAcademicSessionYear}
                className="dropDownBox"
                id="selectOption"
                name="academicYearSession"
                label="Select Academic Year Session"
              >
                {academicYearSessionList?.map((item) => {
                  return (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </div>
          <div className="mb-4">
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Select Shift
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                value={selectedOption}
                onChange={handleChange}
                className="dropDownBox"
                id="selectOption"
                name="selectOption"
                label="Select Shift"
              >
                {academicYearTimeTableShiftList
                  .filter(
                    (item) =>
                      item.academicYearSessionId.id ===
                      selectedOptionAcademicSessionYear,
                  )
                  ?.map((item, index) => {
                    return (
                      <MenuItem key={item.id} value={item.timeTableSession.id}>
                        {item.timeTableSession.name}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
            {/* <label className="mx-2">Select Shift</label>
            <select
              value={selectedOption}
              onChange={handleChange}
              className="dropDownBox"
              id="selectOption"
              name="selectOption"
            >
              <option value="">Select Shift</option>
              {state.loginRes?.timetable_session?.map((item, index) => {
                const key = Object.values(item)[1];
                const value = Object.values(item)[0];
                return (
                  <option key={index} value={value}>
                    {key}
                  </option>
                );
              })}
            </select> */}
          </div>
          <button
            disabled={!selectedOption}
            onClick={handleContinue}
            className="btn continue_button w-25"
            style={{ marginLeft: "250px" }}
          >
            Continue <FontAwesomeIcon icon={faArrowRight} />{" "}
          </button>
        </div>
      )}
    </div>
  );
}
